import { VisibilityRulesInput } from "../../Common/VisibilityRules/VisibilityRulesInput";

export const VisibilityRulesProperty = {
  propertyName: "VisibilityRules",
  propertyDisplay: "Visibility Rules",
  propertyType: "array",
  propertyCategory: "Logic",
  renderer: function ({
    handlePropertyChange,
    currentPropertyValues,
    galleryFields,
    isGalleryEditor,
    columnFields,
    isTableEditor,
  }) {
    return (
      <VisibilityRulesInput
        handlePropertyChange={handlePropertyChange}
        currentPropertyValues={currentPropertyValues}
        defaultValue={currentPropertyValues?.[this.propertyName] || []}
        galleryFields={galleryFields}
        isGalleryEditor={isGalleryEditor}
        columnFields={columnFields}
        isTableEditor={isTableEditor}
      />
    );
  },
};
